import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    cancel: {
        id: "general.cancel",
    },
    modify: {
        id: "general.modify",
    },
    homeworkDescription: {
        id: "homework.description.teacherSide",
    },
    modifySomething: {
        id: "account.modal.changeSomething",
    },
});

export default messages;
